<template>
	<label class='file-upload-ui'>
		<input type='file' :ref='inputId' :multiple='multiple == true' @change='handleInputChange' style='display: none;'>
		<div class='file-upload-ui-button' @click.prevent='showFileInput'>
			<button class='btn btn-primary' v-if="!$slots['button']">
				{{ buttonText }}
			</button>
			<slot name='button'></slot>
		</div>
		<div class='file-upload-ui-loaded'>
			<slot name='files' v-bind:files='files'></slot>
		</div>
	</label>
</template>

<script>
	export default {
		props: {
			value: {
				type: String,
				default: () => {
					return null;
				}
			},

			inputId: {
				type: String,
				default: 'fileInput'
			},

			multiple: {
				type: Boolean,
				default: false
			},

			buttonText: {
				type: String,
				default: 'Select image(s)'
			},

			resetInputEvent: {
				type: String,
				default: 'VueUploadComponentInputReset'
			},

			oneachfile: {
				type: Function,
				default: () => {

				}
			},

			params: {
				type: Array,
				default: () => {
					return [];
				}
			},

			onchange: {
				type: Function,
				default: () => {

				}
			}
		},

		data() {
			return {
				content: this.value,
				files: []
			}
		},

		methods: {
			showFileInput() {
				this.$refs[this.inputId].click();
			},

			handleInputChange(e) {
				let files = e.target.files;
				let onchange = this.onchange;

				if (typeof onchange == 'function') {
					onchange(files, this.params);
				}

				for(let i = 0; i < files.length; i++) {
					let fileIndex = i;
					let file = files[i];
					let uniqueId = Math.random().toString(36).substr(2, 9);
					let reader = new FileReader();
					file.blob = URL.createObjectURL(file);
					file.filename = file.name.replace(/\.[^.$]+$/, '');
					file.extension = file.name.split('.').pop();
					file.uniqueId = uniqueId;
					reader.readAsDataURL(file);
					reader.onload = function() {
						file.base64 = reader.result;
					};

					Object.defineProperty(file, 'url', {
						writable: true,
						enumerable: true
					});

					Object.defineProperty(file, 'type', {
						writable: true,
						enumerable: true
					});

					this.files.push(file);
					if (typeof this.oneachfile == 'function') {
						this.oneachfile(file, this.params, fileIndex);
					}
				}

				return false;
			}
		},

		mounted() {
			this.$root.$on(this.resetInputEvent, () => {
				if (this.$refs[this.inputId] !== undefined) {
					this.$refs[this.inputId].value = '';
				}
			});
		}
	}
</script>